<template>
  <v-text-field
    :value="value"
    :label="label"
    max-length="8"
    @input="colorChanged($event, fromTextInput)"
    v-bind="$attrs"
  >
    <v-icon slot="prepend-inner">fa-hashtag</v-icon>
    <verte slot="append"
           :value="selectedColor"
           picker="square"
           model="hex"
           :enableAlpha="false"
           :showHistory="null"
           @input="colorChanged($event, fromColorPicker)"
           :key="key"
    >
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-icon
            :color="selectedColor"
            :class="{ outlined: selectedColor }"
            v-on="on"
          >
            format_color_fill
          </v-icon>
        </template>
        <span>{{ $t('message.bag.actions.selectColour') }}</span>
      </v-tooltip>
    </verte>
  </v-text-field>
</template>
<script>
import Verte from 'verte';
import 'verte/dist/verte.css';
import uuid from 'uuid/v4';

export default {
  name: 'nx-color-picker',
  mixins: [],
  components: {
    Verte,
  },
  data() {
    return {
      hexRegex: /^[0-9a-fA-F]{6}$/,
      fromTextInput: 'textInput',
      fromColorPicker: 'colorPicker',
      key: null,
    };
  },
  props: {
    value: {
      type: String,
    },
    label: {
      type: String,
      required: true,
    },
    required: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  computed: {
    selectedColor() {
      if (this.hexRegex.test(this.value)) {
        return `#${this.value}`;
      }
      return this.value;
    },
  },
  methods: {
    colorChanged(color, from) {
      if (from === this.fromColorPicker) { // verte
        // Si el input está vacío hasta que el usuario no interactúe con el
        // modal, no cambiamos el valor del input
        // Tenemos que hacer esto ya que Verte intenta actualizar el valor porque
        // no le gustan los nullables
        if (color === '#000000' && !this.value) {
          return;
        }
      }
      const newValue = color.replace('#', '');
      if (newValue !== this.value) {
        this.$emit('input', newValue);
      }
    },
  },
  mounted() {
    setTimeout(() => {
      this.key = uuid();
    }, 500);
  },
};
</script>
<style scoped>
  .v-icon.outlined {
    text-shadow: black 1px 1px 0, black -1px -1px 0, black 1px -1px 0, black -1px 1px 0;
  }
</style>
<style>
.verte__menu-origin--bottom {
  bottom: 50px;
  right: 0
}
</style>
